// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideo_bgVideoWrapper__x6Gr0"};